import React from 'react'
import { GrTrash } from 'react-icons/gr'
import './GlideDelete.css'
import './Glide.css'

export default function GlideDelete({deleter}) {

  const handleMoveToTrash = (e) => {
    deleter();
  }

  return (
    <div className='glideDelete glideCell' onClick={handleMoveToTrash}>
      <GrTrash className='glideTrashIcon'/>
    </div>
  )
}
